/*
 * Our Beam Model class. Defines the client-side data model
 */

/**
 * A finite element node
 * @constructor
 * @param {number} x - the location of this node.
 * @param {string} support - can be "pinned", "fixed" or "free"
 */
class NodeClass {
    constructor(x, support) {
        this.x = x;
        this.support = support;
    }
}

/**
 * A brace point for design checks
 * @constructor
 * @param {number} x - the location of this node.
 * @param {boolean} isSupport - does this brace fall on a support
 */
class BeamBrace {
    constructor(x, isSupport) {
        this.x = x;
        this.isSupport = isSupport;
    }
}

/**
 * A span between two 1d locations
 * @constructor
 * @param {number} x1 - start location
 * @param {number} x2 - end location
 */
class SpanClass {
    constructor(x1, x2) {
        this.x1 = x1;
        this.x2 = x2;
    }

    length() {
        return this.x2 - this.x1;
    }
}

function PointLoad(x, D, L, Lr, S, W, E, H, R, isMoment) {
    this.x = x;
    this.D = D;
    this.L = L;
    this.Lr = Lr;
    this.S = S;
    this.W = W;
    this.E = E;
    this.H = H;
    this.R = R;
    this.isMoment = isMoment;
}

PointLoad.prototype.direction = function() {
    if(this.D < 0) return "up";
    if(this.L < 0) return "up";
    if(this.Lr < 0) return "up";
    if(this.S < 0) return "up";
    if(this.W < 0) return "up";
    if(this.E < 0) return "up";
    if(this.H < 0) return "up";
    if(this.R < 0) return "up";
    return "down";
}

PointLoad.prototype.createLabel = function() {
    let unit = bigPointLoadUnit()
    let label = ""
    let forceFunction = showBigPointLoad;
    if( this.isMoment ){
        unit = bigMomentUnit();
        forceFunction = showBigMoment;
    }

    unit = " " + unit;
    unit += '\n'

    if( this.D != 0 ) label += "D = " + forceFunction(this.D) + unit;
    if( this.L != 0 ) label += " L = " + forceFunction(this.L) + unit;
    if( this.Lr != 0 ) label += " Lr = " + forceFunction(this.Lr) + unit;
    if( this.S != 0 ) label += " S = " + forceFunction(this.S) + unit;
    if( this.W != 0 ) label += " W = " + forceFunction(this.W) + unit;
    if( this.E != 0 ) label += " E = " + forceFunction(this.E) + unit;
    if( this.H != 0 ) label += " H = " + forceFunction(this.H) + unit;
    if( this.R != 0 ) label += " R = " + forceFunction(this.R) + unit;
    return label;
}

function DistLoad(x1, x2, D, L, Lr, S, W, E, H, R, D2, L2, Lr2, S2, W2, E2, H2, R2, isLinear) {
    this.x1 = x1;
    this.x2 = x2;
    this.D = D;
    this.L = L;
    this.Lr = Lr;
    this.S = S;
    this.W = W;
    this.E = E;
    this.H = H;
    this.R = R;
    this.isLinear = isLinear;
    this.D2 = D2;
    this.L2 = L2;
    this.Lr2 = Lr2;
    this.S2 = S2;
    this.W2 = W2;
    this.E2 = E2;
    this.H2 = H2;
    this.R2 = R2;
}

DistLoad.prototype.direction = function()
{
    if(this.D < 0) return "up";
    if(this.L < 0) return "up";
    if(this.Lr < 0) return "up";
    if(this.S < 0) return "up";
    if(this.W < 0) return "up";
    if(this.E < 0) return "up";
    if(this.H < 0) return "up";
    if(this.R < 0) return "up";
    return "down";
}

DistLoad.prototype.Label = function(unit) {
    unit = bigLinearForceUnit();

    var label = "";
    //var factor = 1;
    //if(unit.match(kipPerFtSplit)){
    //    factor = 0.001*12;
    //    unit = " k/ft";
    //}
    if( this.D != 0 || (this.isLinear && this.D != this.D2) ) label += "D = " + showBigLinearForce(this.D) + unit;
    if( this.isLinear && (this.D != this.D2) ) label += " to " + showBigLinearForce(this.D2) + unit;
    if( this.L != 0 || (this.isLinear && this.L != this.L2) ) label += " L = " + showBigLinearForce(this.L) + unit;
    if( this.isLinear && (this.L != this.L2) ) label += " to " + showBigLinearForce(this.L2) + unit;
    if( this.Lr != 0 || (this.isLinear && this.Lr != this.Lr2) ) label += " Lr = " + showBigLinearForce(this.Lr) + unit;
    if( this.isLinear && (this.Lr != this.Lr2)) label += " to " + showBigLinearForce(this.Lr2) + unit;
    if( this.S != 0 || (this.isLinear && this.S != this.S2) ) label += " S = " + showBigLinearForce(this.S) + unit;
    if( this.isLinear && (this.S != this.S2)) label += " to " + showBigLinearForce(this.S2) + unit;
    if( this.W != 0 || (this.isLinear && this.W != this.W2) ) label += " W = " + showBigLinearForce(this.W) + unit;
    if( this.isLinear && (this.W != this.W2 != 0)) label += " to " + showBigLinearForce(this.W2) + unit;
    if( this.E != 0 || (this.isLinear && this.E != this.E2) ) label += " E = " + showBigLinearForce(this.E) + unit;
    if( this.isLinear && (this.E != this.E2)) label += " to " + showBigLinearForce(this.E2) + unit;
    if( this.H != 0 || (this.isLinear && this.H != this.H2) ) label += " H = " + showBigLinearForce(this.H) + unit;
    if( this.isLinear && (this.H != this.H2)) label += " to " + showBigLinearForce(this.H2) + unit;
    if( this.R != 0 || (this.isLinear && this.R != this.R2) ) label += " R = " + showBigLinearForce(this.R) + unit;
    if( this.isLinear && (this.R != this.R2)) label += " to " + showBigLinearForce(this.R2) + unit;
    return label;
}

DistLoad.prototype.Length = function()
{
    return Math.abs(this.x1 - this.x2);
}

DistLoad.prototype.Overlaps = function(b)
{
    return ( (b.x1 >= this.x1 && b.x1 < this.x2 ) ||
            (b.x2 > this.x1 && b.x2 < this.x2 ) ||
            (b.x1 == this.x1 && b.x2 == this.x2) ||
            (b.x1 == this.x2 && b.x2 == this.x1) );
}


/**
 * A finite element beam consisting of nodes, spans and loads
 */
class BeamFlexure {
    constructor () {
        this.nodes = [];
        this.spans = [];
        this.pointLoads = [];
        this.distLoads = [];
        this.linearLoads = [];
        this.crossSectionRotation = 0;
        this.selfWeight = new DistLoad(
            0,100,1, 0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,false);
    }

    static load(json) {
        var o = Object.assign(new BeamFlexure, json);
        o.pointLoads = [];
        o.distLoads = [];
        o.linearLoads = [];
        if("pointLoads" in json) {
            for(let load of json.pointLoads) {
                o.pointLoads.push(Object.assign(new PointLoad, load));
            }
        }
        if("distLoads" in json) {
            for(let load of json.distLoads) {
                o.distLoads.push(Object.assign(new DistLoad, load));
            }
        }
        if("linearLoads" in json) {
            for(let load of json.linearLoads) {
                o.linearLoads.push(Object.assign(new DistLoad, load));
            }
        }
        o.selfWeight = Object.assign(new DistLoad, json.selfWeight);
        o.rebuildSpans();
        return o;
    }

    rebuildSpans() {
        this.spans = [];
        for( var i = 0; i < this.nodes.length-1; i++ )
        {
            var x1 = this.nodes[i].x;
            var x2 = this.nodes[i+1].x;
            this.spans.push( new SpanClass( x1, x2 ) );
        }
    }

    get totalNumberOfLoads() {
        return this.distLoads.length + this.linearLoads.length + this.pointLoads.length;
    }

    TotalLength() {
        if( this.nodes.length <= 1 ){
            return 0;
        }

        var totalLength = 0;
        for( var i = 0; i < this.nodes.length-1; i++ )
        {
            var x1 = this.nodes[i].x;
            var x2 = this.nodes[i+1].x;
            var dist = x2-x1;
            //just in case the nodes are "reversed" happens in IE
            dist = Math.abs(dist);
            totalLength += dist;
        }
        return totalLength;
    }

    isNodeAtThisLocation(x) {
        for(var i = 0; i < this.nodes.length; i++) {
            if(x === this.nodes[i].x) {
                return true;
            }
        }
        return false;
    }

    getPointLoadAtLocation(x) {
        return this.pointLoads.find( pointLoad => Math.abs(pointLoad.x - x) < 1e-6 && !pointLoad.isMoment );
    }

    isSupportPinnedOrFixed(x) {
        const n = this.nodes.find( node => Math.abs(node.x - x) < 1e-6 );
        return (n && n.support !== "free");
    }
}
